<div class="gridContainer">
	<sim-labelled-container icon="fa-cube" label="CREATE_SESSION_DIALOG_CREATE_SESSION">
		<!--TITLE-->
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>{{ T.CREATE_SESSION_DAILOG_SESSION_NAME | translate }}</mat-label>
			<input [formControl]="step1Form.controls.title" [required]="true" matInput />
			@if (step1Form.controls.title.hasError("required")) {
				<mat-error>
					{{ T.CREATE_SESSION_DIALOG_ERROR_MESSAGE | translate }}
				</mat-error>
			}
		</mat-form-field>

		<!--DATE-->
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>{{ T.LABEL_DATE | translate }}</mat-label>
			<input
				(click)="datepicker.open()"
				[formControl]="step1Form.controls.date"
				[matDatepicker]="datepicker"
				[max]="eventEndDate"
				[min]="eventStartDate"
				matInput
				readonly
			/>
			@if (step1Form.controls.date.hasError("required")) {
				<mat-error>{{ T.ERROR_INVALID | translate: {item: T.LABEL_DATE | translate} }} </mat-error>
			}
			<mat-datepicker-toggle [for]="datepicker" matIconSuffix>
				<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fa" matDatepickerToggleIcon />
			</mat-datepicker-toggle>
			<mat-datepicker #datepicker />
		</mat-form-field>

		<!--TIME-->
		<sim-clock-time-input [formCtrl]="step1Form.controls.time" [labelKey]="T.SHARED_EVENT_SESSION_ESTIMATED_TIME_START" />
	</sim-labelled-container>

	<sim-labelled-container icon="fa-folder-tree" label="EXAM_SESSION_DIALOG_STEP1_EXAM_STAGES" class="config">
		<!--CONFIRMATION-->
		<div class="formRow">
			<sim-duration-input
				[formCtrl]="step1Form.controls.confirmationDurationMinutes"
				[min]="0"
				[labelToken]="T.EXAM_SESSION_DIALOG_STEP1_CONFIRMATION_DURATION | translate"
				class="field"
				suffixFontIcon="fa-portal-enter"
			/>
			<sim-info-hover [tooltip]="T.EXAM_SESSION_DIALOG_STEP1_CONFIRMATION_DESC" />
		</div>

		<!--EXAM FLOW-->
		<div class="formRow">
			<sim-chip-autocomplete
				[dataType]="FetchDataType.ExamFlow"
				[formCtrl]="step1Form.controls.examFlow"
				[labelToken]="T.LABEL_EXAM_FLOW"
				class="field"
			>
				<mat-icon labelPrefix fontIcon="fa-folder-tree" fontSet="fad" />
			</sim-chip-autocomplete>
			<sim-info-hover [tooltip]="T.EXAM_SESSION_DIALOG_STEP1_EXAM_FLOW_DESC" />
		</div>

		<!--CLOSING-->
		<div class="formRow">
			<sim-duration-input
				[formCtrl]="step1Form.controls.closingDurationMinutes"
				[min]="0"
				[labelToken]="T.EXAM_SESSION_DIALOG_STEP1_CLOSING_DURATION"
				class="field"
				suffixFontIcon="fa-portal-exit"
			/>
			<sim-info-hover [tooltip]="T.EXAM_SESSION_DIALOG_STEP1_CLOSING_DESC" />
		</div>
	</sim-labelled-container>

	<sim-labelled-container icon="fa-tv-alt" label="EXAM_SESSION_DIALOG_FLOOR_SCREEN">
		<div class="formRow">
			<sim-autocomplete
				(onSelect)="addRoom($any($event))"
				[dataType]="FetchDataType.TrainingRoom"
				[excludeIds]="excludeRoomIds()"
				[labelToken]="T.CREATE_SESSION_DIALOG_FLOOR_LABEL"
				subscriptSizing="fixed"
				class="field"
			>
				<ng-container actions>
					<button (click)="openRoomDetailDialog()" color="accent" mat-icon-button>
						<mat-icon fontIcon="fa-th" fontSet="fad" />
					</button>
				</ng-container>
			</sim-autocomplete>
			<sim-info-hover [tooltip]="T.EXAM_SESSION_DIALOG_STEP1_FLOOR_SCREEN_DESC" />
		</div>

		<div class="roomList">
			@if (floorScreenRooms()?.length) {
				<div class="scrollViewport">
					@for (room of floorScreenRooms(); track room.id) {
						<sim-list-item
							[primaryLabel]="room.name"
							[indicator]="{fontIcon: 'fa-door-open', fontSet: 'fa'}"
							[selectable]="false"
						>
							<ng-container actions>
								<button mat-icon-button color="warn" (click)="removeRoom(room)">
									<mat-icon fontIcon="fa-times" fontSet="fa" />
								</button>
							</ng-container>
						</sim-list-item>
					}
				</div>
			} @else {
				<div class="emptyState">
					<mat-icon fontSet="fad" fontIcon="fa-door-open" />
					<span [innerHTML]="T.EXAM_SESSION_DIALOG_NO_FLOOR_SCREENS | translate"></span>
				</div>
			}
		</div>
	</sim-labelled-container>
</div>
